import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../environments/environment';
import { StartupService } from './startup.service';
import { WoodGrainImage } from '../models/wood-grain-image.model';

@Injectable()
export class WoodGrainImageService {

  constructor(private http: HttpClient, private startupService: StartupService) {
  }

  getWoodGrainImage(): Promise<WoodGrainImage[]> {
    return this.http.get<WoodGrainImage>(`${environment.apiUrl}/woodGrainImage/${this.startupService.websiteName}`)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error')).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/wood-grain.service.ts